import api from './api';

const expenseCategoryService = {
  getAll: async () => {
    const response = await api.get('/api/expense-categories');
    return response.data;
  },

  create: async (name) => {
    const response = await api.post('/api/expense-categories', { name });
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/api/expense-categories/${id}`);
    return response.data;
  },
};

export default expenseCategoryService;